export default "__VITE_ASSET__CAnGRq7R__"